var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkSimple",
    clipPath: "url(#clip0_501_25247)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4213 4.93131L11.6055 7.74152C11.2704 8.07593 10.7277 8.07538 10.3933 7.74031C10.0589 7.40524 10.0594 6.86253 10.3945 6.52813L13.217 3.71131C14.2244 2.72016 15.5827 2.16726 16.9959 2.17302C18.4091 2.17877 19.7628 2.74273 20.7622 3.74204C21.7615 4.74136 22.3254 6.09507 22.3312 7.5083C22.3369 8.92154 21.784 10.2798 20.7929 11.2872L20.7875 11.2927L17.9693 14.1061C17.6343 14.4406 17.0916 14.4401 16.7572 14.1051C16.4227 13.7701 16.4232 13.2274 16.7582 12.8929L19.5734 10.0824C20.2458 9.39759 20.6208 8.47508 20.6169 7.51528C20.613 6.55428 20.2295 5.63376 19.55 4.95423C18.8704 4.27469 17.9499 3.8912 16.9889 3.88729C16.0289 3.88338 15.1062 4.25861 14.4213 4.93131ZM16.1061 8.39389C16.4408 8.72863 16.4408 9.27134 16.1061 9.60607L10.1061 15.6061C9.77136 15.9408 9.22864 15.9408 8.89391 15.6061C8.55917 15.2713 8.55917 14.7286 8.89391 14.3939L14.8939 8.39389C15.2286 8.05916 15.7714 8.05916 16.1061 8.39389ZM8.24238 11.1055C8.57678 10.7704 8.57624 10.2277 8.24117 9.89329C7.9061 9.55889 7.36339 9.55943 7.02899 9.8945L4.21647 12.7126L4.21218 12.717C3.22103 13.7244 2.66812 15.0826 2.67387 16.4959C2.67963 17.9091 3.24358 19.2628 4.2429 20.2621C5.24221 21.2615 6.59592 21.8254 8.00916 21.8312C9.42239 21.8369 10.7807 21.284 11.7881 20.2929L14.607 17.4693C14.9414 17.1343 14.941 16.5916 14.606 16.2571C14.2709 15.9227 13.7282 15.9231 13.3938 16.2581L10.5832 19.0734C9.89844 19.7458 8.97593 20.1208 8.01614 20.1169C7.05514 20.113 6.13462 19.7295 5.45508 19.05C4.77555 18.3704 4.39206 17.4499 4.38814 16.4889C4.38423 15.5289 4.75946 14.6061 5.43217 13.9213L8.24238 11.1055Z",
    fill: "#192851"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_501_25247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBlack);
export default __webpack_public_path__ + "static/media/LinkBlack.fe758f2cac51205b623bf2e6b9181cbf.svg";
export { ForwardRef as ReactComponent };